'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeEmailSettingsProperty = exports.CHANGE_PROPERTY = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _index = require('./index');

var _errorMsgs = require('../../../constants/errorMsgs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_PROPERTY = exports.CHANGE_PROPERTY = 'tq-plus-admin/emailSettings/CHANGE_PROPERTY';

var initialState = {
    // Saved data
    current: []
};
/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_PROPERTY:
            return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.field, action.value));
        case _index.GET_GENERICSETTINGS_TYPES.SUCCESS:
            {
                var emailSettings = action.genericSettings && action.genericSettings.emailSettings || {};

                return (0, _extends4.default)({}, state, emailSettings, {
                    current: emailSettings
                });
            }
        case _index.CANCEL:
            return (0, _extends4.default)({}, state, state.current);
        default:
            return state;
    }
}

/* VALIDATE
*------------------------------------------------------------------------------------------------ */
/* export function validateGenericSettings(data) {

  let mail = data.currentTemplate.fromEmail;
  let user = data.currentTemplate.userName;
  let tplId = data.currentTemplate.markingId;
  let tplName = data.currentTemplate.name;
  let templates = data.templates;
  let txtNotification = '';
  let validateResult = {
    msg: '',
    validated : false
  }
  let uniqId = true;
  let uniqName = true;

  Object.keys(templates).map(key => {
      let obj = templates[key];
      if(tplId === obj.markingId) {
        uniqId = false;
      }
      if(tplName === obj.name) {
        uniqName = false;
      }
   });

  if(mail && user && uniqName && uniqId) {
    validateResult.msg = '';
    validateResult.validated = true;
  } else {
      if(!mail){txtNotification += 'Email' + ERR_EMPTY_FIELD}
      if(!user){txtNotification += 'User Name' + ERR_EMPTY_FIELD}
      if(!uniqName){txtNotification += 'Template name' + ERR_REPEATED_FIELD}
      if(!uniqId){txtNotification += 'Template ID' + ERR_REPEATED_FIELD}
    validateResult.msg = txtNotification;
  }
  return validateResult;
}
*/

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var changeEmailSettingsProperty = exports.changeEmailSettingsProperty = function changeEmailSettingsProperty(field, value) {
    return {
        type: CHANGE_PROPERTY, field: field, value: value
    };
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/emailSettings.js
// module id = 1657
// module chunks = 0